/* HomeMedix — mobile product hero logic (phones only). Pairs with assets/hm-pdp-mobile.css.
   1. Builds the brand + rating line above the title from the existing vendor + rating markup (cloned; desktop keeps its own).
   2. Lifts the Liquid-rendered sticky bar to <body>, mirrors the real Add-to-cart button (label, disabled, Rx lock, insurance mode)
      and shows it once the real buttons scroll off screen.
      Oct 18, 2026: the bar never lists the picked options. Three states: available = price + Add to cart; sold out = price +
      "Out of stock" + a "Get notified" button that scrolls to the back-in-stock box (snippets/hm-oos.liquid); not offered
      (no variant for the picked options) = the row title's red reason, no price, greyed Add to cart.
   3. Makes the Shop Pay installments line tappable (opens the same modal as its "Learn more" link). */
(function () {
  if (window.__hmMobInit) return;
  window.__hmMobInit = true;
  var MQ = window.matchMedia('(max-width: 749px)');
  var io = null, ioAnchor = null, trustTpl = null;
  function q(s, r) { return (r || document).querySelector(s); }
  function bar() { return q('body > [data-hm-mob-sticky]'); }
  function lift() {
    var b = bar(); if (b) return b;
    var el = q('[data-hm-mob-sticky]'); if (el) document.body.appendChild(el);
    return el;
  }
  function meta() {
    var info = q('.product__info-container');
    if (!info || q('.hm-mob-meta', info)) return;
    var vendor = q('.product__text.custom-venndoor', info), rev = q('.custom-reviews-pdp', info);
    if (!vendor && !rev) return;
    var m = document.createElement('div'); m.className = 'hm-mob-meta';
    if (vendor) { var b = document.createElement('span'); b.className = 'hm-mob-meta__brand'; b.textContent = vendor.textContent.trim(); m.appendChild(b); }
    if (rev) {
      if (vendor) { var d = document.createElement('span'); d.className = 'hm-mob-meta__dot'; d.setAttribute('aria-hidden', 'true'); m.appendChild(d); }
      m.appendChild(rev.cloneNode(true));
    }
    info.insertBefore(m, info.firstChild);
  }
  function watch(node, opts) {
    if (!node || node.__hmWatched) return;
    node.__hmWatched = true;
    new MutationObserver(function () { sync(); }).observe(node, opts);
  }
  function trust() {
    var src = q('[data-hm-mob-trust]');
    if (!trustTpl && src) { trustTpl = src.cloneNode(true); trustTpl.hidden = false; src.remove(); }
    var info = q('.product__info-container');
    if (!trustTpl || !info || q('.hm-mob-trust', info)) return;
    info.appendChild(trustTpl.cloneNode(true));
  }
  var galleryProps = ['height', 'max-height', 'padding', 'position', 'inset', 'width', 'max-width', 'margin', 'object-fit', 'aspect-ratio'];
  function setImp(el, map) { for (var k in map) el.style.setProperty(k, map[k], 'important'); }
  function gallery() {
    var g = q('media-gallery') || q('.product__media-wrapper'); if (!g) return;
    var imgs = Array.prototype.filter.call(g.querySelectorAll('img'), function (i) { return !i.closest('.thumbnail-slider, .thumbnail-list, .product-media-modal'); });
    if (!MQ.matches) {
      imgs.forEach(function (i) { if (i.__hmG) { galleryProps.concat(['display']).forEach(function (p) { i.style.removeProperty(p); }); i.__hmG = false; } var p = i.parentElement; while (p && p !== g) { if (p.__hmG) { galleryProps.forEach(function (k) { p.style.removeProperty(k); }); p.__hmG = false; } p = p.parentElement; } });
      return;
    }
    var h = Math.round(window.innerWidth * 0.6) + 'px';
    imgs.forEach(function (i) {
      i.__hmG = true;
      setImp(i, { position: 'static', display: 'block', height: h, 'max-height': h, width: '100%', 'max-width': '100%', 'object-fit': 'contain', 'aspect-ratio': 'auto', margin: '0' });
      var p = i.parentElement;
      while (p && p !== g) { p.__hmG = true; setImp(p, { padding: '0', height: 'auto', 'max-height': 'none', width: '100%', 'max-width': '100%', margin: '0' }); if (p.classList.contains('product__media-item') || p.classList.contains('hm-fetaured-img')) break; p = p.parentElement; }
    });
    var sb = g.querySelector('.slider-buttons');
    if (sb && g.querySelectorAll('.product__media-item').length > 1 && !g.querySelector('.hm-fetaured-img')) sb.classList.remove('small-hide');
  }
  window.addEventListener('resize', function () { gallery(); });
  var padState = false;
  function intercomEls() { return document.querySelectorAll('.intercom-lightweight-app-launcher, .intercom-launcher-frame, iframe[name="intercom-launcher-frame"], .intercom-launcher, #intercom-container .intercom-app > iframe, .intercom-namespace .intercom-app > iframe, .intercom-lightweight-app-messenger, .intercom-messenger-frame'); }
  function intercomPad(up, force) {
    if (padState === up && !force) return;
    padState = up;
    if (typeof window.Intercom === 'function') { try { window.Intercom('update', { vertical_padding: up ? 92 : 20 }); } catch (e) { /* ignore */ } }
    intercomEls().forEach(function (el) { if (up) el.style.setProperty('bottom', '92px', 'important'); else el.style.removeProperty('bottom'); });
  }
  new MutationObserver(function () { if (padState) intercomPad(true, true); }).observe(document.body, { childList: true });
  function selVar() {
    var sv = q('.product__info-container variant-selects [data-selected-variant]');
    if (!sv) return undefined;
    try { return JSON.parse(sv.textContent); } catch (e) { return undefined; }
  }
  /* 'na' = the picked options match no variant (assets/hm-oos.js sets .hm-oos-na; the theme's selected-variant JSON is null),
     'out' = the picked variant (or the whole product) is sold out, 'ok' = buyable */
  function state() {
    if (q('product-info.hm-oos-na')) return 'na';
    if (q('product-info.hm-oos-all')) return 'out';
    var v = selVar();
    if (v === null) return 'na';
    if (v && v.available === false) return 'out';
    if (v === undefined) { var s = q('.product-form__submit'); if (s && s.disabled && q('[data-hm-oos]')) return 'out'; }
    return 'ok';
  }
  function sync() {
    meta(); trust(); gallery();
    var b = lift(); if (!b) return;
    var submit = q('.product-form__submit'), notify = q('[data-hm-oos]'), st = state();
    var mode = document.documentElement.getAttribute('data-hm-pay-mode') || '';
    var canNotify = st === 'out' && !!notify;
    if (!MQ.matches || mode === 'insurance' || (!submit && !canNotify)) { b.hidden = true; document.body.classList.remove('hm-mob-sticky-shown'); intercomPad(false); return; }
    var btn = q('[data-hm-mob-atc]', b);
    if (canNotify) {
      btn.textContent = 'Get notified';
      btn.disabled = false;
      btn.setAttribute('data-hm-mob-notify', '');
      btn.classList.remove('is-locked');
    } else {
      var txt = q('.product-form__text', submit);
      btn.textContent = (txt || submit).textContent.trim();
      btn.disabled = submit.disabled;
      btn.removeAttribute('data-hm-mob-notify');
      btn.classList.toggle('is-locked', mode === 'retail-locked');
    }
    var pe = q('[data-hm-mob-price]', b), sub = q('[data-hm-mob-sub]', b);
    var price = q('.custom-price-pdpp .price__sale .price-item--sale') || q('.custom-price-pdpp .price-item--regular');
    if (pe) { if (st === 'na') pe.textContent = ''; else if (price) pe.textContent = price.textContent.trim(); }
    if (sub) {
      if (st === 'na') { var r = q('.product__info-container .hm-vst--na'); sub.textContent = r ? r.textContent.trim() : 'Not offered in this size'; }
      else sub.textContent = st === 'out' ? 'Out of stock' : '';
    }
    b.classList.toggle('hm-mob-na', st === 'na');
    b.classList.toggle('hm-mob-out', st === 'out');
    b.hidden = false;
    if (submit) watch(submit, { attributes: true, childList: true, subtree: true });
    watch(q('.custom-price-pdpp'), { childList: true, subtree: true, characterData: true });
    watch(q('product-info'), { attributes: true, attributeFilter: ['class'] });
    /* the bar appears once its anchor scrolls off the top: the buy buttons, or the back-in-stock box when that replaces them */
    var anchor = (canNotify && !notify.hidden) ? notify : q('.custom-pdp-by-main');
    if (anchor && anchor !== ioAnchor) {
      if (io) io.disconnect();
      ioAnchor = anchor;
      io = new IntersectionObserver(function (e) {
        var s = bar(); if (!s) return;
        var show = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
        s.classList.toggle('is-shown', show);
        document.body.classList.toggle('hm-mob-sticky-shown', show && !s.hidden);
        intercomPad(show && !s.hidden);
      }, { threshold: 0 });
      io.observe(anchor);
    }
  }
  function toNotify() {
    var n = q('[data-hm-oos]'); if (!n) return;
    var hh = 0;
    document.querySelectorAll('sticky-header, .header-wrapper').forEach(function (el) { hh = Math.max(hh, el.getBoundingClientRect().height); });
    window.scrollTo({ top: n.getBoundingClientRect().top + window.pageYOffset - hh - 16, behavior: 'smooth' });
    var inp = q('.hmo-inp', n);
    if (inp) setTimeout(function () { try { inp.focus({ preventScroll: true }); } catch (e) { inp.focus(); } }, 450);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hm-mob-atc]');
    if (t) { if (t.hasAttribute('data-hm-mob-notify')) { toNotify(); return; } var s = q('.product-form__submit'); if (s) s.click(); return; }
    var f = e.target.closest('form.installment');
    if (f && !e.target.closest('button, a')) {
      var el = q('shopify-payment-terms', f);
      var open = el && el.shadowRoot && el.shadowRoot.querySelector('button');
      if (open) open.click();
    }
  });
  document.addEventListener('product-info:loaded', function () { setTimeout(sync, 0); });
  if (MQ.addEventListener) MQ.addEventListener('change', sync); else MQ.addListener(sync);
  function boot() {
    sync();
    new MutationObserver(sync).observe(document.documentElement, { attributes: true, attributeFilter: ['data-hm-pay-mode'] });
    if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      try { subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(sync, 60); }); } catch (e) { /* ignore */ }
    }
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
